// extracted by mini-css-extract-plugin
var _1 = "anfCq";
var _2 = "SDWOv";
var _3 = "wPvZ8";
var _4 = "BXg7Y";
var _5 = "xC970";
export { _1 as "base", _2 as "content", _3 as "inspector", _4 as "main", _5 as "sidebar" }
